export default __webpack_public_path__ + "static/media/ic_time-webinar-blue.80d8440a.svg";